var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      "x-large": "",
                      color: "light-blue lighten-2",
                      icon: "fa-plus",
                      tooltip: _vm.$t("global.crud.button.add")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.create()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "6", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.datatable.search"),
                                  "append-icon": "fas fa-search",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.filter.allFields,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "allFields", $$v)
                                  },
                                  expression: "filter.allFields"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "6", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.deletedItemsValues,
                                  label: _vm.$t("global.status")
                                },
                                model: {
                                  value: _vm.filter.deletedItems,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "deletedItems", $$v)
                                  },
                                  expression: "filter.deletedItems"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: { url: "/clients", filter: this.filter }
                  }),
                  _c("ImportExcel", {
                    attrs: { url: "/clients" },
                    on: { done: _vm.search }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                "item-key": "code",
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "body",
                    fn: function(ref) {
                      var items = ref.items
                      return [
                        _c(
                          "tbody",
                          _vm._l(items, function(item) {
                            return _c("tr", { key: item.code }, [
                              _c(
                                "td",
                                [
                                  _c("crud-button", {
                                    attrs: {
                                      "x-small": "",
                                      color: "orange",
                                      icon: "fa-pen",
                                      tooltip: _vm.$t(
                                        "global.crud.buttons.edit"
                                      )
                                    },
                                    on: {
                                      clicked: function($event) {
                                        return _vm.edit(item.code)
                                      }
                                    }
                                  }),
                                  item.deletionDate === undefined ||
                                  item.deletionDate === null
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "red",
                                          icon: "fa-trash",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.delete"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.suspend(item.code)
                                          }
                                        }
                                      })
                                    : _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "green",
                                          icon: "fa-redo",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.restore"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.restore(item.code)
                                          }
                                        }
                                      })
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.code))]),
                              _c("td", [_vm._v(_vm._s(item.name))]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.logoFileId !== undefined &&
                                        item.logoFileId !== null
                                        ? _vm.$t("global.yes")
                                        : _vm.$t("global.no")
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    }
                  },
                  _vm._l(_vm.headers, function(header, i) {
                    return {
                      key: "item." + header.value,
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("span", { key: i }, [
                            header.value === "actions"
                              ? _c(
                                  "span",
                                  { staticStyle: { "white-space": "nowrap" } },
                                  [
                                    _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "orange",
                                        icon: "fa-pen",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.edit"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.edit(item.code)
                                        }
                                      }
                                    }),
                                    item.deletionDate === undefined ||
                                    item.deletionDate === null
                                      ? _c("crud-button", {
                                          attrs: {
                                            "x-small": "",
                                            color: "red",
                                            icon: "fa-trash",
                                            tooltip: _vm.$t(
                                              "global.crud.buttons.delete"
                                            )
                                          },
                                          on: {
                                            clicked: function($event) {
                                              return _vm.suspend(item.code)
                                            }
                                          }
                                        })
                                      : _c("crud-button", {
                                          attrs: {
                                            "x-small": "",
                                            color: "green",
                                            icon: "fa-redo",
                                            tooltip: _vm.$t(
                                              "global.crud.buttons.restore"
                                            )
                                          },
                                          on: {
                                            clicked: function($event) {
                                              return _vm.restore(item.code)
                                            }
                                          }
                                        })
                                  ],
                                  1
                                )
                              : _c(
                                  "span",
                                  [
                                    _vm._t(
                                      "field:" + header.value,
                                      [
                                        _vm._v(
                                          " " + _vm._s(item[header.value]) + " "
                                        )
                                      ],
                                      { value: item[header.value], item: item }
                                    )
                                  ],
                                  2
                                )
                          ])
                        ]
                      }
                    }
                  })
                ],
                null,
                true
              )
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var invalid = ref.invalid
                  var validated = ref.validated
                  var passes = ref.passes
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("clients.code"),
                                            rules: "required|max:30"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "clients.code"
                                                        ),
                                                        disabled: _vm.editMode,
                                                        required: "",
                                                        "error-messages": errors,
                                                        counter: "30"
                                                      },
                                                      model: {
                                                        value: _vm.item.code,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "code",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.code"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("clients.name"),
                                            rules: "required|max:60"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "clients.name"
                                                        ),
                                                        required: "",
                                                        "error-messages": errors,
                                                        counter: "60"
                                                      },
                                                      model: {
                                                        value: _vm.item.name,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.name"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _vm.item.logoFileName !== undefined &&
                                        _vm.item.logoFileName !== null &&
                                        _vm.item.logoFileName !== ""
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "100%"
                                                    }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "clients.logoFile"
                                                        ),
                                                        disabled: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.logoFileName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "logoFileName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.logoFileName"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("button", {
                                                  staticClass:
                                                    "v-icon notranslate v-icon--link fas fa-times-circle theme--light",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.item.logoFileName = ""
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          : _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "clients.logoFile"
                                                ),
                                                rules: "size:8192"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("v-file-input", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "clients.logoFile"
                                                            ),
                                                            accept:
                                                              "image/png, image/jpeg, image/bmp, image/gif",
                                                            "error-messages": errors
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item.logoFile,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "logoFile",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.logoFile"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }